import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
} from '@mui/material';
import { useMain } from '../../hooks/useMain';

const ExpiryBranches = ({ filterBy, startDate, endDate, searchTerm }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { fetchexpiringbranch } = useMain();

  useEffect(() => {
    const getExpiringBranches = async () => {
      setLoading(true);
      const params = {};
      if (filterBy) params.filterBy = filterBy;
      if (searchTerm) params.search = searchTerm;
      if (filterBy === 'customDate' && startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      try {
        const res = await fetchexpiringbranch(params);
        if (res.statusCode === 200) {
          setData(res.data?.branches || []);
        }
      } catch (error) {
        console.error('Error fetching expiring branches', error);
      } finally {
        setLoading(false);
      }
    };

    if (filterBy === 'customDate' && (!startDate || !endDate)) {
      return;
    }
    getExpiringBranches();
  }, [filterBy, startDate, endDate, fetchexpiringbranch, searchTerm]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  const filteredData = (data || []).filter((item) => {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase();
    const name = item.branchName?.toLowerCase() || '';
    const phone = item.phone || item.branchPhone || '';
    return name.includes(term) || phone.includes(term);
  });

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>Expiring Branches</Typography>
      <Box sx={{ overflow: 'auto', width: { xs: '280px', sm: 'auto' }, maxHeight: '500px' }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Table aria-label="simple table" sx={{ whiteSpace: 'nowrap', mt: 2 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ color: 'white', fontWeight: '600', borderRadius: '10px 0 0 10px', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>
                Branch Name
              </TableCell>
              <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Branch Phone</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Duration</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: '600', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>Start Date</TableCell>
              <TableCell sx={{ color: 'white', fontWeight: '600', borderRadius: '0 10px 10px 0', background: '#6174DD', position: 'sticky', top: 0, zIndex: 1 }}>
                End Date
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData && filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.branchName}</TableCell>
                  <TableCell>{item.phone || item.branchPhone || 'N/A'}</TableCell>
                  <TableCell>{item.subscriptionDetails?.duration?.duration || 'N/A'}</TableCell>
                    <TableCell>{formatDate(item.subscriptionDetails?.duration?.startDate)}</TableCell>
                    <TableCell>{formatDate(item.subscriptionDetails?.duration?.endDate)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography>No expiring branches found</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </Box>
    </Box>
  );
};

export default ExpiryBranches;

// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Typography,
//   CircularProgress,
// } from '@mui/material';
// import { useMain } from '../../hooks/useMain';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';

// const ExpiryBranches = ({ filterBy, startDate, endDate }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { fetchexpiringbranch } = useMain();

//   useEffect(() => {
//     const getExpiringBranches = async () => {
//       setLoading(true);
//       const params = {};
//       if (filterBy) params.filterBy = filterBy;
//       if (filterBy === 'customDate' && startDate && endDate) {
//         params.startDate = startDate;
//         params.endDate = endDate;
//       }

//       try {
//         const res = await fetchexpiringbranch(params);
//         if (res.statusCode === 200) {
//           setData(res.data?.branches || []);
//         }
//       } catch (error) {
//         console.error('Error fetching expiring branches', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (filterBy === 'customDate' && (!startDate || !endDate)) return;
//     getExpiringBranches();
//   }, [filterBy, startDate, endDate, fetchexpiringbranch]);

//   return (
//     <DashboardCard2
//       title="Expiring Branches"
//       sx={{
//         height: 'auto',
//         minHeight: 'unset',
//         display: 'block',
//       }}
//     >
//       <Box
//         sx={{
//           width: '100%',
//           overflowX: 'auto',
//         }}
//       >
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
//             <CircularProgress />
//           </Box>
//         ) : (
//           <Table aria-label="expiring branches" sx={{ whiteSpace: 'nowrap', mt: 2 }}>
//             <TableHead>
//               <TableRow>
//                 <TableCell sx={headerStyle('left')}>Branch Name</TableCell>
//                 <TableCell sx={headerStyle()}>Branch Phone</TableCell>
//                 <TableCell sx={headerStyle()}>Duration</TableCell>
//                 <TableCell sx={headerStyle()}>Start Date</TableCell>
//                 <TableCell sx={headerStyle('right')}>End Date</TableCell>
//               </TableRow>
//             </TableHead>

//             <TableBody>
//               {data.length > 0 ? (
//                 data.map((item, index) => (
//                   <TableRow key={index}>
//                     <TableCell>{item.branchName}</TableCell>
//                     <TableCell>{item.phone || item.branchPhone || 'N/A'}</TableCell>
//                     <TableCell>{item.subscriptionDetails?.duration?.duration || 'N/A'}</TableCell>
//                     <TableCell>{item.subscriptionDetails?.duration?.startDate || 'N/A'}</TableCell>
//                     <TableCell>{item.subscriptionDetails?.duration?.endDate || 'N/A'}</TableCell>
//                   </TableRow>
//                 ))
//               ) : (
//                 <TableRow>
//                   <TableCell colSpan={5} align="center">
//                     <Typography>No expiring branches found</Typography>
//                   </TableCell>
//                 </TableRow>
//               )}
//             </TableBody>
//           </Table>
//         )}
//       </Box>
//     </DashboardCard2>
//   );
// };

// const headerStyle = (side) => ({
//   color: 'white',
//   fontWeight: 600,
//   background: '#6174DD',
//   position: 'sticky',
//   top: 0,
//   zIndex: 1,
//   borderRadius:
//     side === 'left'
//       ? '10px 0 0 10px'
//       : side === 'right'
//       ? '0 10px 10px 0'
//       : 0,
// });

// export default ExpiryBranches;
